import { atom } from 'recoil'
import { StateKeys } from '../../../../constants/stateKeys'

export type FirstFavoritePropertyState = 'true' | 'false' | 'pending'

export const firstFavoritePropertyState = atom<FirstFavoritePropertyState>({
  key: StateKeys.firstFavoriteProperty,
  default: 'false'
})
